import { useSelector } from 'react-redux';
import { isOwnerAndReceiverSame, isReceiverForProjectAnOrganization } from '../../project/project-model';
import ProfileInfo from './ProfileInfo';
import { isUsersProject } from '../../project/project-selectors';
import { getUser } from '../user-selectors';
import { formatVerifiedOwnerName } from '../user-model';
import { USER_TYPE } from '../../constants';
import styles from './profileInfo.module.less';

const ProfileInfoFactory = ({
    project,
    imageSize,
    disableEdit,
    textContainerClassName,
    urlForOrganizationNavigation,
}) => {
    const user = useSelector(getUser);
    const isMyProject = isUsersProject(user, project.id);
    const isOrganizationVerified = project.receiver?.type === USER_TYPE.ORG && project.receiver?.verified;
    const orgBadgeTitle = isOrganizationVerified ? 'Organisasjonen har blitt verifisert' : '';

    if (isReceiverForProjectAnOrganization(project) && isOwnerAndReceiverSame(project.owner, project.receiver)) {
        const title = project.receiver.name;
        const creatorName = project.owner?.name;
        const subtitle = creatorName ? `Opprettet av ${creatorName}` : null;
        const ownerImage =
            project.profile?.overrideOwnerImage !== null ? project.profile?.overrideOwnerImage : project.owner?.img_url;

        return (
            <ProfileInfo
                title={title}
                verified={isOrganizationVerified}
                hideBadge={true}
                badgeTitle={orgBadgeTitle}
                subtitle={subtitle}
                imageSize={imageSize}
                imageClassNameLeft={styles.imageLeft}
                imageSrcLeft={ownerImage}
                isEditable={isMyProject && !disableEdit}
                textContainerClassName={textContainerClassName}
                urlForOrganizationNavigation={urlForOrganizationNavigation}
            />
        );
    } else if (project.receiver?.type === USER_TYPE.ORG) {
        const creatorName = project.owner?.name;
        const subtitle = creatorName ? `Opprettet av ${creatorName}` : null;
        const title = project.receiver.name;
        const imageSrc = project.receiver.img_url;
        return (
            <ProfileInfo
                title={title}
                hideBadge={true}
                subtitle={subtitle}
                badgeTitle={orgBadgeTitle}
                imageSize={imageSize}
                imageClassNameLeft={styles.imageLeft}
                imageSrcLeft={imageSrc}
                isEditable={false}
                textContainerClassName={textContainerClassName}
                urlForOrganizationNavigation={urlForOrganizationNavigation}
            />
        );
    }

    const verifiedOwnerName = formatVerifiedOwnerName(project.owner?.verified_name);
    const verifiedReceiverName = formatVerifiedOwnerName(project.receiver?.verified_name);
    const isReceiverVerified = !!verifiedReceiverName;
    const isOwnerVerified = !!project.owner?.verified;

    const ownerImage =
        project.profile?.overrideOwnerImage !== null ? project.profile?.overrideOwnerImage : project.owner?.img_url;
    // User created project without organization
    return (
        <ProfileInfo
            title={verifiedOwnerName || project.owner?.name}
            verified={isOwnerVerified}
            badgeTitle={isOwnerVerified ? 'Identifisert' : 'Innsamler har ikke identifisert seg'}
            subtitle={isReceiverVerified ? `Pengene utbetales til ${verifiedReceiverName}` : ''}
            imageSize={imageSize}
            imageClassNameLeft={styles.imageLeft}
            imageSrcLeft={ownerImage}
            isEditable={isMyProject && !disableEdit}
            textContainerClassName={textContainerClassName}
        />
    );
};

export default ProfileInfoFactory;
